<template>
  <div id="tx_types_container">
    <b style="align-self: center" v-if="$mq == 'sm'">Filter</b>

  <div id="tx_types_subcontainer" v-bind:class="$mq">
    <b   style="align-self: center" v-if="$mq != 'sm'">Filter</b>
    <div class="tx_type_separator"  v-bind:class="$mq" v-if="$mq != 'sm'">|</div>

    <div id="txs_payments"
         class="tx_type"
         v-bind:class="[$mq, should_fade('payments') ? 'faded_type' : '']"
         v-on:click="toggle('payments')"
         title="Payments">
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">Payments</span>

      <img v-bind:src="type_glyph('Payment')"
           class="type_glyph" v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.payments}}</span>
    </div>

    <div class="tx_type_separator" v-bind:class="$mq">|</div>

    <div id="txs_offers"
         class="tx_type"
         v-bind:class="[$mq, should_fade('offers') ? 'faded_type' : '']"
         v-on:click="toggle('offers')"
         title="Offers">
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">Offers</span>

      <img v-bind:src="type_glyph('OfferCreate')"
           class="type_glyph" v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.offers}}</span>
    </div>

    <div class="tx_type_separator" v-bind:class="$mq">|</div>

    <div id="txs_escrows"
         class="tx_type"
         v-bind:class="[$mq, should_fade('escrows') ? 'faded_type' : '']"
         v-on:click="toggle('escrows')"
         title="Escrows" >
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">Escrows</span>

      <img v-bind:src="type_glyph('EscrowCreate')"
           class="type_glyph" v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.escrows}}</span>
    </div>

    <div class="tx_type_separator" v-bind:class="$mq">|</div>

    <div id="txs_paychans"
         class="tx_type"
         v-bind:class="[$mq, should_fade('paychans') ? 'faded_type' : '']"
         v-on:click="toggle('paychans')"
         title="Payment Channels" >
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">PayChans</span>

      <img v-bind:src="type_glyph('PaymentChannelClaim')"
           class="type_glyph" v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.paychans}}</span>
    </div>

    <div class="tx_type_separator" v-bind:class="$mq">|</div>

    <div id="txs_account_sets"
         class="tx_type"
         v-bind:class="[$mq, should_fade('account_sets') ? 'faded_type' : '']"
         v-on:click="toggle('account_sets')"
         title="Account Sets" >
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">Account Sets</span>

      <img v-bind:src="type_glyph('AccountSet')"
           class="type_glyph"  v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.account_sets}}</span>
    </div>

    <div class="tx_type_separator" v-bind:class="$mq">|</div>

    <div id="txs_trust_sets"
         class="tx_type"
         v-bind:class="[$mq, should_fade('trust_sets') ? 'faded_type' : '']"
         v-on:click="toggle('trust_sets')"
         title="Trust Lines" >
      <span class="tx_type_title" v-if="$mq == 'sm' || $mq == 'md'">Trust Sets</span>

      <img v-bind:src="type_glyph('TrustSet')"
           class="type_glyph" v-bind:class="$mq" />

      <span class="tx_tally" v-bind:class="$mq">{{tallies.trust_sets}}</span>
    </div>
  </div>
  </div>
</template>

<script>

export default {
  name: 'LiveTxsTypes',

  computed : {
    tallies : function(){
      return this.$store.state.tx_tallies;
    }
  },

  methods : {
    should_fade : function(t){
      if(!this.$store.state.filter_tx_types)
        return false;

      return !this.$store.helpers.is_tx_enabled(t);
    },

    type_glyph : function(t){
      return require("../../assets/txs/" + t + ".svg");
    },

    toggle : function(t){
      this.$store.commit('toggle_tx_type', t);
    }
  }
}
</script>

<style scoped>
#tx_types_container{
  border: solid 2px rgba(33, 189, 202, 0.2);
  padding: 2px;
  margin-bottom: 10px;
}

#tx_types_subcontainer{
  display: flex;
  justify-content: space-around;
  padding-top: 1px;
}

.tx_type{
  min-height: 25px;
  cursor: pointer;
  float: left;
  font-weight: bold;
  margin: 3px;
}

.tx_type.sm,
.tx_type.md{
  font-size: 0.8em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.faded_type{
  opacity: 0.6;
}

.tx_type_title{
  font-size: 0.9em;
}

.tx_type_separator{
  color: rgba(33, 189, 202, 0.2);
  font-size: 1.2em;
  font-weight: bold;
}

.tx_type_separator.sm,
.tx_type_separator.md{
  display: none;
}

.type_glyph{
  width: 25px;
  margin-left: 5px;
}

.type_glyph.sm,
.type_glyph.md{
  width: 25px;
  margin-left: 0;
}

.tx_tally{
  margin-right: 10px;
  margin-left: 10px;
  padding: 3px;
  color: white;
  background-color: #36c2cf;
  border-radius: 3px;

  display: inline-block;
  min-width: 35px;
  text-align: center;
}

.tx_tally.sm{
  margin-right: 0px;
  margin-left: 0px;
  margin-top: 3px;
  min-width: 25px;
}
</style>
